export const TABLE_CONSTANTS = {
    CAMPAIGN_NAME: 244,
    CAMPAIGN_STAGES: 502,
    INBOUND: 88
}